// Schemas for the groups domain (CTSK-240). Groups were read-only
// (GET /groups, GET /groups/:id) from Phase 0 until 0.1.87 — these
// shapes back the CRUD + membership-mutation routes that wire up the
// previously-unused `groups:manage` capability.
//
// Field limits follow the organization schemas' grammar (name ≤ 120
// like StarterContainerSchema, description ≤ 1000, ULIDs ≤ 26).
import { z } from 'zod';
// POST /groups — create. `description` is nullable-optional so the UI
// can send null to mean "no description" (matches the groups table,
// where description is a nullable text column).
/**
 * Strict (CTSK-445) — unknown keys are rejected with 400
 * VALIDATION_ERROR naming the offending key, instead of Zod's default
 * silent strip. Class-fix for the CTSK-427 silent-drop bug (memory
 * feedback_zod_field_name_silent_drop).
 */
export const GroupCreateSchema = z.object({
    name: z.string().min(1).max(120),
    description: z.string().max(1000).nullable().optional(),
}).strict();
// PATCH /groups/:id — rename / edit description. All fields optional;
// sending description: null clears it.
export const GroupPatchSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    description: z.string().max(1000).nullable().optional(),
});
// POST /groups/:id/members — add a member by ULID. Unlike org
// memberships there's no role attached (group_roles is a separate
// link table, out of CTSK-240 scope), so the body is just the user.
export const GroupMemberAddSchema = z.object({
    userId: z.string().min(1).max(26),
});
//# sourceMappingURL=group.js.map